// extracted by mini-css-extract-plugin
export var cards = "SquareCards-module--cards--3hK5V";
export var SquareCardsModuleCards3hK5V = "SquareCards-module--SquareCards-module--cards--3hK5V--1ZC2s";
export var customerImage = "SquareCards-module--customer-image--23hkz";
export var arrow = "SquareCards-module--arrow--10mpD";
export var black = "SquareCards-module--black--1Ia9N";
export var blue = "SquareCards-module--blue--2MHdm";
export var white = "SquareCards-module--white--2Ok0Q";